var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, createApp, ref, watch } from "vue";
import ProductCardApp from "./ProductCardApp.vue";
import { extractAppData, isWebpSupported } from "../../../utils";
import { hidePreloader } from "../../../components/preloader";
import useProductApi from "../api/productApi";
import { getCartOffersList } from "../../../components/cart";
import EventBus from "../../../events/EventBus";
let thumbsSlider;
let productSlider;
export default function initProductOfferApp(bigSwiper, smallSwiper) {
    return __awaiter(this, void 0, void 0, function* () {
        const el = document.getElementById('productOfferApp');
        const newInterfaceTrigger = document.getElementById('offer-mode-switch');
        const description = document.getElementById('product_description');
        const slide = document.querySelector('#prod-item-swiper .swiper-slide:first-child');
        const thumbSlide = document.querySelector('#prod-nav-swiper .swiper-slide:first-child');
        const textElement = document.getElementById('product_text');
        if (!el || !newInterfaceTrigger || !description || !slide || !thumbSlide || !textElement) {
            return;
        }
        thumbsSlider = smallSwiper;
        productSlider = bigSwiper;
        const data = extractAppData(el);
        const appData = yield useProductApi(data.productId).request();
        const { pages, product } = appData;
        const type = ref(data.activeType ? appData.types.find(t => data.activeType === t.id) : null);
        const offer = ref(data.activeOffer ? product.offers.find(o => data.activeOffer === o.id) : null);
        const interacted = ref(data.activeType !== null || data.activeOffer !== null);
        const cartOffers = ref(getCartOffersList());
        const page = computed(() => type.value && pages[type.value.id] ? pages[type.value.id] : pages[product.id]);
        EventBus.on('cart:update', offers => cartOffers.value = offers);
        createApp(ProductCardApp, {
            product: appData.product,
            types: appData.types,
            delivery: data.delivery,
            newInterface: newInterfaceTrigger.checked,
        }).provide('type', type).provide('offer', offer).provide('cart', cartOffers).provide('interacted', interacted).mount(el);
        watch([type, offer, interacted], ([type, offer, interacted]) => {
            if (!interacted) {
                return;
            }
            history.replaceState(undefined, undefined, buildUrl(product.url, type, offer));
            updateDescription();
            if (offer === null || offer === void 0 ? void 0 : offer.image) {
                updateImage(offer.image);
            }
            else if (page.value.image && page.value.image.big.webp.hiDPI !== product.image.big.webp.hiDPI) {
                updateImage(page.value.image);
            }
            else {
                updateImage();
            }
        });
        function updateDescription() {
            if (product.category === 'perfume') {
                description.innerHTML = type.value ? type.value.name : '';
            }
            textElement.innerHTML = page.value.text;
        }
        hidePreloader(false, el);
    });
}
function buildUrl(baseUrl, type, offer) {
    let url = baseUrl;
    if (type) {
        url += `${type.code}/`;
    }
    if (offer) {
        url += `?offer=${offer.id}`;
    }
    return url;
}
function updateImage(image = null) {
    const extension = isWebpSupported() ? 'webp' : 'jpeg';
    const offerSlide = productSlider.wrapperEl.querySelector('.prod-slider__item--offer');
    const thumbOfferSlide = thumbsSlider.wrapperEl.querySelector('.prod-cover-nav__item--offer');
    if (image) {
        const slide = `
      <a href="${image.big[extension].hiDPI}" class="prod-slider__link" tabindex="0" data-pswp-width="${image.width}" data-pswp-height="${image.height}">
        ${makePicture(image.big, image.mobile)}
      </a>
    `;
        if (!offerSlide) {
            productSlider.prependSlide(`<div class="prod-slider__item swiper-slide prod-slider__item--offer">${slide}</div>`);
            thumbsSlider.prependSlide(`<div class="prod-cover-nav__item prod-cover-nav__item--offer swiper-slide">${makePicture(image.tiny)}</div>`);
            productSlider.slideTo(0);
        }
        else {
            offerSlide.innerHTML = slide;
            thumbOfferSlide.innerHTML = makePicture(image.tiny);
            productSlider.slideTo(0);
        }
    }
    else if (offerSlide) {
        productSlider.slideTo(1);
        productSlider.removeSlide(0);
        thumbsSlider.removeSlide(0);
    }
}
function makePicture(image, mobileImage = null) {
    const ext = isWebpSupported() ? 'webp' : 'jpeg';
    return `
    <picture>
      ${mobileImage ? `<source type="image/${ext}" media="(max-width: 450px)" srcset="${mobileImage[ext].loDPI}, ${mobileImage[ext].hiDPI} 2x">` : ''}
      <img src="${image[ext].loDPI}" srcset="${image[ext].hiDPI} 2x" alt="">
    </picture>
  `;
}
